import { If } from "lib/@components/switch"
import { IconButton, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { JustificationUpdatedBy } from "./justification-updated-by"
import { prevent } from "lib/prevent"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { RegimeDraftLockHide } from "routes/regime/regime-draft-locking/regime-draft-lock-hide"

export function JustificationDisplay({ payload, onEdit }) {
    const { allowEdit = true, isEditable = true } = useBoundContext()

    return (
        <>
            <Stack
                direction="row"
                sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                        alignItems: "center",
                    }}
                >
                    <Iconify icon="basil:comment-solid" sx={{ color: "primary.main", width: "20px", height: "20px" }} />
                    <Typography variant="subtitle2">Justification</Typography>
                </Stack>
                <If truthy={allowEdit && isEditable}>
                    <RegimeDraftLockHide>
                        <IconButton
                            aria-label="Edit justification"
                            onClick={prevent(onEdit)}
                            data-cy="edit-justification-button"
                        >
                            <Iconify icon="mdi:pencil" sx={{ color: "primary.main", width: "16px", height: "16px" }} />
                        </IconButton>
                    </RegimeDraftLockHide>
                </If>
            </Stack>
            <Typography
                variant="body2"
                dangerouslySetInnerHTML={{ __html: payload?.reason }}
                sx={{ wordBreak: "break-word", whiteSpace: "pre-line" }}
            />
            <JustificationUpdatedBy payload={payload} />
        </>
    )
}
